import { useMesfRealtime } from "@dexteel/mesf-core";
import { useQueryClient } from "@tanstack/react-query";

const SP_TO_QUERY_KEYS: Record<string, readonly string[][]> = {
  "RBD.GetStrandLossesByShift": [["strand-losses-by-shift"]],
  "DEL.GetDelayCategories": [["strand-loss-categories"]],
  "DEL.GetDelayCodes": [["strand-loss-codes"]],
};

export const useRealtimeInvalidation = () => {
  const queryClient = useQueryClient();

  useMesfRealtime({
    onReceiveMessage: (_author: string, message: string) => {
      const queryKeys = SP_TO_QUERY_KEYS[message];
      if (!queryKeys) return;

      for (const queryKey of queryKeys) {
        queryClient.invalidateQueries({ queryKey });
      }
    },
  });
};
